import ko from "knockout";
import FancyTreeWrapper from "flow/wrappers/FancyTreeWrapper";
import { registerKnockoutBinding } from "flow/knockout/register";

export * from "flow/wrappers/FancyTreeWrapper";

registerKnockoutBinding("fancytree", {
    init(element: HTMLElement, valueAccessor: () => any) {
        const value = valueAccessor();

        const wrapper = new FancyTreeWrapper(element);

        if (ko.isObservable(value)) {
            const handle = value as KnockoutObservable<FancyTreeWrapper>;
            handle(wrapper);
        } else {
            const options = value as Fancytree.FancytreeOptions;
            wrapper.create(options);
        }

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            wrapper.destroy();
        });
    }
});
